import axios from 'axios'
import { DATAMASTER_ENDPOINT } from '../../endpoints'
import moment from 'moment'
import * as FileSaver from 'file-saver';
import {toast} from 'react-toastify'
import { XML_TYPE } from 'Utilities';

export async function getExcelPrices(isClassicView){
    try {
        if (isClassicView) {
            const response =  await axios(`${DATAMASTER_ENDPOINT}/getPricesReportClassicView`,
                {
                    method: "GET",
                    timeout: 150000
                }
            )
            const res = response.data

            // TODO: maybe generate a helper function
            const link = document.createElement('a');
            link.href = res.downloadUrl;
            document.body.appendChild(link);
            toast.success('Archivo descargado correctamente')
            link.click();
            document.body.removeChild(link);

            // TODO: check return if not multiple toasts
            return ''
        } else {
            const dateNow = moment(new Date()).format("DD-MM-YYYY")
             const response =  await axios(`${DATAMASTER_ENDPOINT}/getPricesReport`,{responseType:"blob",method:"GET"}) 

             const file = new Blob(
                 [response.data],
                 {
                   type: XML_TYPE,
                 }
              )

              FileSaver.saveAs(file, `Precios de referencia-${dateNow}.xlsx`)
        }

    } catch (error) {
        toast.error('Algo salió mal, intentá de nuevo en unos minutos.')
    }
}
